"use strict"

import BaseCustomLayer from "./BaseCustomLayer";

export default class LineCustomLayer extends BaseCustomLayer {

  constructor(id, data, options = {}) {
    super(id, LineCustomLayer.name, data, options);
    this.lineColor = options.lineColor || "#0DFE29";
    this.fillColor = options.fillColor || "rgba(255,0,255,0.5)";
    this.lineWidth = options.lineWidth || 4;
    this.pointColor = options.pointColor || "#0DCEFE";
    this.pointSize = options.pointSize || 4;
    this.backgroundColor = options.backgroundColor || "rgba(255,255,255,0.5)";

  }

  /**
   * 将数据转化为饼图
   * @param item
   * { point:[112.6,45],values:[[2011,32],[2012,36],[2022,45]],}
   * @param colors
   * ["","",]
   */
  createChart(item, colors) {
    let cvs = document.createElement('canvas');

    cvs.width = this.params.width;//设置canvas宽
    cvs.height = this.params.height;//设置canvas高


    this.goBarChart(item.values, cvs);
    let image = new Image();
    image.src = cvs.toDataURL("image/png");
    image.style.cursor = "pointer"
    return image;
  }

  goBarChart(dataArr, canvas) {
    let that = this;

    // 声明所需变量
    let ctx;
    // 图表属性
    let cWidth, cHeight;
    let originX, originY;
    // 柱状图属性
    let tobalBars, bWidth, maxValue;


    // 获得canvas上下文
    if (canvas && canvas.getContext) {
      ctx = canvas.getContext("2d");
    } else {
      return
    }
    initChart(); // 图表初始化
    drawLineLabelMarkers(); // 绘制图表轴、标签和标记
    drawLineAnimate(); // 绘制柱状图的动画

    // 图表初始化
    function initChart() {
      // 图表信息
      cHeight = canvas.height;
      cWidth = canvas.width;
      originX = 0;
      originY = cHeight;

      // 柱状图信息
      tobalBars = dataArr.length;
      bWidth = Math.round(cWidth / tobalBars);

      maxValue = 0;
      for (let i = 0; i < dataArr.length; i++) {
        let barVal = parseInt(dataArr[i]);
        if (barVal > maxValue) {
          maxValue = barVal;
        }
      }
      maxValue += 10;

      drawRect(0,0,cWidth,cHeight,that.backgroundColor)

    }

    // 绘制图表轴、标签和标记
    function drawLineLabelMarkers() {
      ctx.translate(0.5, 0.5);  // 当只绘制1像素的线的时候，坐标点需要偏移，这样才能画出1像素实线
      ctx.font = "12px Arial";
      ctx.lineWidth = 1;
      ctx.fillStyle = "#000";
      ctx.strokeStyle = "#000";
      ctx.translate(-0.5, -0.5);  // 还原位置
    }


    //绘制折线图
    function drawLineAnimate() {
      ctx.strokeStyle = that.lineColor;
      ctx.lineWidth = that.lineWidth;
      //连线
      ctx.beginPath();
      for (let i = 0; i < tobalBars; i++) {
        let dotVal = dataArr[i];

        let barH = Math.round(cHeight * dotVal / maxValue);

        let y = originY - barH;
        let x = originX + bWidth * (i+0.5);
        console.log(x,y)
        if (i === 0) {
          ctx.moveTo(x, y);
        } else {
          ctx.lineTo(x, y);
        }
      }
      ctx.stroke();

      //背景
      ctx.lineTo(originX + bWidth * (tobalBars - 0.5), originY);
      ctx.lineTo(originX+bWidth/2, originY);
      //背景渐变色
      //柱状图渐变色

      ctx.fillStyle = that.fillColor;
      ctx.fill();
      ctx.closePath();
      ctx.fillStyle = that.pointColor;

      //绘制点
      for (let i = 0; i < tobalBars; i++) {
        let dotVal = dataArr[i];
        let barH = Math.round(cHeight * dotVal / maxValue);
        let y = originY - barH;
        let x = originX + bWidth * (i+0.5);
        drawArc(x, y);  //绘制点
      }

    }

    //绘制圆点
    function drawArc(x, y) {
      ctx.beginPath();
      ctx.arc(x, y, that.pointSize, 0, Math.PI * 2);
      ctx.fill();
      ctx.closePath();
    }
    //绘制方块
    function drawRect( x, y, X, Y,color ){

      ctx.beginPath();
      ctx.rect( x, y, X, Y );
      ctx.fillStyle = color;

      ctx.fill();
      ctx.closePath();
    }
  }
}



// WEBPACK FOOTER //
// ./src/layer/LineCustomLayer.js